import { render, staticRenderFns } from "./KPKMap.vue?vue&type=template&id=1129e97c&scoped=true&"
import script from "./KPKMap.vue?vue&type=script&lang=js&"
export * from "./KPKMap.vue?vue&type=script&lang=js&"
import style0 from "./KPKMap.vue?vue&type=style&index=0&id=1129e97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129e97c",
  null
  
)

export default component.exports